import styled, { createGlobalStyle } from 'styled-components';

/**
 * This form component works with the legacy components
 * like typography and inputs; these global styles are
 * copied from the previous implementation of the credit card form
 * and _are needed to force the dark mode_.
 * After re-doing the form and the whole payment flow
 * for the next Grover design system, this should be deleted.
 */
export const StyledForm = styled.form`
    visibility: ${(props) => (props.isVisuallyHidden ? 'hidden' : 'visible')};
    padding: 30px;
    background: #d0d0d012;
    border: 1px solid #eee;
    flex: 1;
    margin-top: 15px;
    margin-left: 0;
    margin-right: 0;
`;

export const GlobalDarkThemeFormStyles = createGlobalStyle`
    ${(props) => props.theme && props.theme.mode === 'dark' && `
        ${StyledForm} .getgroverForm_Box__label,
        ${StyledForm} .getgroverFormInput input,
        ${StyledForm} .getgroverForm_Box--active .getgroverForm_Box__label,
        ${StyledForm} .getgroverFormCheckbox__label,
        ${StyledForm} .getgroverForm_Box--active .getgroverFormInput input {
        color: #fff;
        }

        ${StyledForm} .getgroverForm_Box--active .getgroverForm_Box__box {
        border-color: #fff;
        }

        ${StyledForm} .getgroverForm_Box--error .getgroverForm_Box__box {
        border-color: #FE1251;
        }

    `}
`;

export const SplitBox = styled.div`
    display: flex;
`;
export const SplitBoxItem = styled.div`
    &:nth-child(1){
      margin-right: 15px;
    }
    flex: 1;
`;

export const iframeInputStyleObject = ({ mode }) => ({
    padding: '15px 0 0',
    width: '100%',
    height: '100%',
    color: mode === 'dark' ? 'white' : '#333333',
    'font-size': '16px',
    'line-height': '1.2',
    'font-weight': '300',
    background: 'transparent',
    position: 'relative',
    border: 'none',
    outline: 'none',
    transition: 'color .2s ease',
    'font-family': '"helvetica neue", helvetica, arial, sans-serif',
    'letter-spacing': '0.2px',
    'word-spacing': '-0.2px',
});
